import { adminPath, type AdminClient } from '../../modules/core/index.js'
import { readMarked, type Marked } from '../../modules/add-ons/index.js'
import type { InsightsPortfolio } from './types.js'

/** The Executive Insights add-on's read-only admin mirror the client detail reads: the portfolio, with where the add-on stands for the client. */
export interface ExecutiveInsightsAdminApi {
  insightsPortfolio(clientId: string, months: number): Promise<Marked<InsightsPortfolio>>
}

/** Built by the add-on's own admin section from the client the registry hands it, as the add-on mounts its own routes on the API. */
export function createExecutiveInsightsAdminApi(client: AdminClient): ExecutiveInsightsAdminApi {
  return {
    insightsPortfolio: (clientId, months) => readMarked(client, `${adminPath.client(clientId)}/insights/portfolio?months=${months}`),
  }
}
